/* eslint no-console:0 */
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
require.context('../img', true);

import '../stylesheets/app.sass';
import './index.js';
